define('view/controller/booking/datetime/flexible/TimeFlexibleHourView',['require','marionette','lib/Utils','view/controller/booking/datetime/flexible/TimeFlexibleHourItemView','lib/view/UnwrapBehavior'],function (require) {

    var Marionette = require('marionette');
    var Utils = require('lib/Utils');
    var TimeFlexibleHourItemView = require('view/controller/booking/datetime/flexible/TimeFlexibleHourItemView');
    var UnwrapBehavior = require('lib/view/UnwrapBehavior');

    /**
     * Flexible timeline view (container)
     *
     * @class TimeFlexibleHourView
     */
    return Marionette.CompositeView.extend({

        template: '#time_flexible_hour_view',
        childView: TimeFlexibleHourItemView,
        childViewContainer: '.sb_time_flexible_hour_container',
        childViewOptions: function (model, index) {
            return {
                clientTimeZone: this.getOption('clientTimeZone')
            };
        },
        behaviors: {
            UnwrapBehavior: {
                behaviorClass: UnwrapBehavior
            }
        },

        initialize: function () {
            this.collection = this.model.get('collection');
        },

        serializeData: function () {
            var result = Marionette.ItemView.prototype.serializeData.apply(this);
            result.time_diff = Utils.timeDiff(result, this.getOption('clientTimeZone'));

            return result;
        },

        onChildviewHoverTime: function (view, data) {
            if (data.model.get('type') === 'free') {
                this.triggerMethod('hover:time', data.model);
            }
        },

        onChildviewSelectTime: function (view, data) {
            if (data.model.get('type') === 'free') {
                this.triggerMethod('select:time', data.model);
            }
        }

    });

});
